import clientDataPic from '../../../assets/images/cap_1.png'
import Button from '../../../components/Button'
import { useStepsContext } from '../../../context/StepsContext'
import ManualIdForm from './ManualIdForm'

const IdValidation = () => {
  const { idStep, setIdStep }: any = useStepsContext()
  const startValidation = () => {
    setIdStep(idStep + 1)
  }

  return (
    <>
      <main hidden={idStep} className="landing">
        <div className="landing-container">
          <img id="id-validation-img-cap-1" src={clientDataPic} style={{ maxHeight: '100px' }} />
          <h3 id="id-validation-h3-datos-cliente">Datos del cliente</h3>
          <p className="recommendations">
            Validación de la
            <br />
            documentación de identidad
          </p>
          <Button
            id="id-validation-scan"
            landing
            label="Continuar"
            className="submit-button"
            handleSubmit={startValidation}
          />
        </div>
      </main>
      {idStep !== 0 && <ManualIdForm />}
    </>
  )
}

export default IdValidation
